import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { fmtDate, fmtEuro } from "@/lib/format";

const MONTHS = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
const SEL = "h-8 border bg-white px-2 text-sm";

const Row = ({ r }) => {
  const { nameOf } = useData();
  const code = nameOf("companies", r.company_id, "code");
  return (
    <tr className="border-b align-top" data-testid={`loan-summary-row-${code}`}>
      <td className="py-1.5 pr-2"><div className="font-semibold">{nameOf("companies", r.company_id, "legal_name")}</div>
        <div className="text-[11px] text-muted-foreground">{r.loans.map((l) => `${fmtDate(l.date_from)}–${fmtDate(l.date_to)}`).join(", ") || "Nessun prestito nel periodo"}</div>
        {r.befs.length > 0 && <div className="text-[11px]">{r.befs.map((b) => <Link key={b.id} to="/amministrazione?tab=bef" className="mr-2 font-mono text-primary underline" data-testid={`loan-summary-bef-${b.id}`}>{b.number === "BOZZA" ? "Bozza" : b.number}</Link>)}</div>}
      </td>
      <td className="text-right font-mono" data-testid="loan-summary-days">{r.days}</td>
      <td className="text-right font-mono">{r.orders}</td>
      <td className="text-right font-mono" data-testid="loan-summary-in-bef">{fmtEuro(r.in_bef)}</td>
      <td className="text-right font-mono">{fmtEuro(r.draft)}</td>
      <td className="text-right font-mono" data-testid="loan-summary-to-bill">{fmtEuro(r.to_bill)}</td>
    </tr>
  );
};

export const LoanSummary = ({ emp }) => {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState("");
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/loans/employee/${emp.id}/summary`, { params: { year, month: month || undefined } }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [emp.id, year, month]);
  const years = Array.from({ length: 4 }, (_, i) => now.getFullYear() - i);
  return (
    <div className="mt-6" data-testid="loan-summary">
      <div className="mb-2 flex items-center justify-between gap-2 border-b pb-1">
        <span className="micro-label">Prestiti intercompany</span>
        <div className="flex gap-1">
          <select className={SEL} value={month} onChange={(e) => setMonth(e.target.value)} data-testid="loan-summary-month"><option value="">Tutto l'anno</option>{MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}</select>
          <select className={SEL} value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="loan-summary-year">{years.map((y) => <option key={y} value={y}>{y}</option>)}</select>
        </div>
      </div>
      {!d?.rows.length ? <p className="text-sm text-muted-foreground" data-testid="loan-summary-empty">Nessun prestito o lavoro intercompany nel periodo.</p> : (
        <table className="w-full text-sm">
          <thead><tr className="border-b text-left text-[10px] uppercase text-muted-foreground"><th className="py-1">Società</th><th className="text-right">Giorni</th><th className="text-right">Interv.</th><th className="text-right">In BEF</th><th className="text-right">In bozza</th><th className="text-right">Da mettere in BEF</th></tr></thead>
          <tbody>{d.rows.map((r) => <Row key={r.company_id} r={r} />)}
            <tr className="font-semibold" data-testid="loan-summary-totals"><td className="py-1.5">Totale</td><td className="text-right font-mono">{d.totals.days}</td><td className="text-right font-mono">{d.totals.orders}</td>
              <td className="text-right font-mono">{fmtEuro(d.totals.in_bef)}</td><td className="text-right font-mono">{fmtEuro(d.totals.draft)}</td><td className="text-right font-mono">{fmtEuro(d.totals.to_bill)}</td></tr>
          </tbody>
        </table>
      )}
      <p className="mt-1 text-[11px] text-muted-foreground">Giorni = giorni con almeno un intervento validato per la società che ha ricevuto il prestito. Valori al 100% del listino validato.</p>
    </div>
  );
};
